export default {
    backend:"https://testcab.sah.md",
	cabinet:"https://sah.md"
}
